module.exports = __webpack_public_path__ + "static/media/searpent_logo_black_long.b83ea746.png";